import App from 'app/app.js';
import './confirm-modal.scss';
import '@app/components/core/lt-icon/lt-icon.component';
import template from './confirm-modal.html';

function ltConfirmModal() {
  return {
    restrict: 'E',
    scope: {
      iconName: '@',
      drawerTheme: '@',
      drawerTitleKey: '@',
      drawerDescKey: '@',
      drawerDescParams: '@',
      drawerCautionMessageKey: '@',
      cancelKey: '@',
      buttonKey: '@',
      buttonLayout: '@',
      onCancel: '&',
      onEmit: '&'
    },
    template,
    controllerAs: 'confirmCtrl'
  };
}

App.directive('ltConfirmModal', [ltConfirmModal]);
